var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIoIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14h10a3 3 0 003-3H0a3 3 0 003 3zm10-2h1v1h-1v-1zm2-10H1l-1 8h16z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIoIcon);
export default __webpack_public_path__ + "static/media/io-icon.6b404a0e6f9893c802292a65e3432c3f.svg";
export { ForwardRef as ReactComponent };